import { Gauge, Boxes, Library, Settings2, PenTool, Sparkles, Images, FileText, Building2, Palette, IdCard, Inbox, SlidersHorizontal, Handshake } from 'lucide-react';

/** V17.0 — Architecture de la page projet : 4 sections, sous-onglets. */
export const SECTIONS = [
  { id: 'dashboard', label: 'Dashboard', icon: Gauge, sub: 'KPI · Arborescence · Jalons', tabs: [] },
  { id: 'production', label: 'Production', icon: Boxes, sub: 'Préparation · Génération · Galerie',
    tabs: [
      { id: 'preparation', label: 'Préparation', icon: PenTool, hint: 'Plans, traçage, environnement, bâtiments, lots' },
      { id: 'generation', label: 'Génération', icon: Sparkles, hint: 'Maquette, shoebox, perspectives' },
      { id: 'galerie', label: 'Galerie', icon: Images, hint: 'Visuels validés, étapes commerciales, exports' },
    ] },
  { id: 'ressources', label: 'Ressources', icon: Library, sub: 'Fichiers · Structures · Matériauthèque',
    tabs: [
      { id: 'fichiers', label: 'Fichiers', icon: FileText },
      { id: 'structures', label: 'Structures', icon: Building2 },
      { id: 'materiautheque', label: 'Matériauthèque', icon: Palette },
    ] },
  { id: 'settings', label: 'Paramètres', icon: Settings2, sub: 'Identité · Demande · Caractéristiques',
    tabs: [
      { id: 'identite', label: 'Identité & calendrier', icon: IdCard },
      { id: 'demande', label: 'Demande client', icon: Inbox },
      { id: 'caracteristiques', label: 'Caractéristiques', icon: SlidersHorizontal },
      { id: 'commercial', label: 'Commercial', icon: Handshake },
    ] },
];

const LEGACY = {
  maquette: ['production', 'preparation'], blueprint: ['production', 'preparation'], 'plan-editor': ['production', 'preparation'], 'site-plan': ['production', 'preparation'],
  studio: ['production', 'generation'],
  dossier: ['ressources', 'fichiers'], engineering: ['ressources', 'structures'],
  setup: ['settings', 'demande'], brief: ['settings', 'demande'], commercial: ['settings', 'commercial'],
  'geometry-status': ['dashboard', null],
};

export const sectionById = (id) => SECTIONS.find((s) => s.id === id);

/** Résout `?section=&tab=` (y compris anciennes URL) en { section, tab } valides. */
export const resolveSection = (rawSection, rawTab, search) => {
  let section = rawSection || 'dashboard';
  let tab = rawTab || null;
  if (LEGACY[section]) {
    const [s, t] = LEGACY[section];
    if (section === 'maquette' && (search?.get('review') || search?.get('lot_id'))) { section = 'production'; tab = search.get('review') ? 'generation' : 'preparation'; }
    else { section = s; tab = tab || t; }
  } else if (section === 'production' && !tab) {
    tab = 'generation';  // ancien onglet « Production » = rendus
  }
  const def = sectionById(section) || sectionById('dashboard');
  const validTab = def.tabs.find((t) => t.id === tab) ? tab : (def.tabs[0]?.id || null);
  return { section: def.id, tab: validTab };
};
